import * as R from 'ramda';
export function getPaginatedData(paginatedQuery) {
    return R.pathOr([], ['data', 'data'])(paginatedQuery);
}
export function flattenPaginatedQueriesResults(paginatedQueries) {
    return R.chain(getPaginatedData)(paginatedQueries);
}
export function flattenInfiniteQueryResults(query) {
    return R.pipe(R.pathOr([], ['data', 'pages']), R.chain(R.prop('data')))(query);
}
export function flattenInfiniteCosmosData(query) {
    return R.pipe(R.pathOr([], ['data', 'pages']), R.chain(R.pathOr([], ['data', 'documents'])))(query);
}
